import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

import { verifyToken } from '../../actions/user'
import { getValidToken } from '../../helpers/tokenManager.helper'
import { useAuth } from '../../hooks/useAuth'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

function PrivateRoute ({ Component }) {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const token = useSelector((state) => state.token)
  const { isLoading } = useAuth()

  useEffect(() => {
    let isActive = true
    if (isActive) verify()
    return () => { isActive = false }
  }, [])

  async function verify () {
    if (token) {
      try {
        // Try to get a valid token (this will refresh if needed)
        const { token: validToken } = await getValidToken()

        // Verify the token with the backend
        const res = await verifyToken(user, validToken)
        if (res.data) {
          const { token: newToken } = res.data
          window.localStorage.setItem('token', JSON.stringify(newToken))
          dispatch({
            type: 'UPDATED_TOKEN',
            payload: newToken
          })
        }
      } catch (err) {
        console.error('Token verification failed:', err)
        // Clear all stored data and redirect to login
        dispatch({ type: 'LOGOUT_CLIENT', payload: null })
        dispatch({ type: 'LOGOUT_USER', payload: null })
        dispatch({ type: 'LOGOUT_TOKEN', payload: null })
        dispatch({ type: 'CLEAR_TABLE', payload: null })
        dispatch({ type: 'CLEAR_DOCTORS', payload: null })

        // Clear localStorage
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('client')
      }
    }
  }

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <LoadingSpinner message='Verificando autenticación...' />
  }

  return token ? <Outlet /> : <Navigate to='/' />
}

export default PrivateRoute
